<template>
  <Modal
    v-model="visible"
    :title="$LocalH5('sealOrSign.secondVerrifi')"
    @on-cancel="oncancel">
    <Form ref="form" :model="form" :rules="formRules" :label-width="80" style="padding: 10px 20px 30px 20px;">
      <FormItem :label="$LocalH5('sealOrSign.phone')" prop="cellphone">
        <Input v-model.trim="form.cellphone" :placeholder="$LocalH5('sealOrSign.inputEnter')"/>
      </FormItem>
      <FormItem :label="$LocalH5('sealOrSign.sendCode')" prop="code">
        <Row>
          <Col span="16">
            <Input v-model.trim="form.code" :placeholder="$LocalH5('sealOrSign.inputEnter')"/>
          </Col>
          <Col span="6" offset="1">
            <Button @click="sendCode" :disabled="loading || count > 0">{{ count > 0 ? $LocalH5('sealOrSign.countdown',{key:count}) : $LocalH5('sealOrSign.getValidCode') }}</Button>
          </Col>
        </Row>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button size="large" @click="oncancel">{{$LocalH5('buttonCancel')}}</Button>
      <Button type="primary" size="large"  @click="onconform" :disabled="!(form.cellphone && form.code)">{{$LocalH5('buttonConfirm')}}</Button>
    </div>
  </Modal>
</template>
<script>
  import { getVerificationCode, checkVerificationCode } from '@/api/comment'
  export default {
    name: "second-verification",
    data() {
      const cellphonePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$LocalH5('sealOrSign.validPhone')));
        } else {
          if (!/^1[3|4|5|7|8][0-9]{9}$/.test(value)) {
            callback(new Error(this.$LocalH5('sealOrSign.validPhoneMsg')));
          }
          callback();
        }
      }
      return {
        visible: !!this.value,
        form: {
          cellphone: '',
          code: ''
        },
        formRules: {
          cellphone: [
            { required: true, validator: cellphonePass, trigger: 'blur' }
          ],
          code: [
            { required: true, message: this.$LocalH5('sealOrSign.validCode'), trigger: 'blur' }
          ]
        },
        count: -1,
        loading: false,
        timer: null
      }
    },
    props: {
      value: Boolean
    },
    watch: {
      value(val) {
        this.visible = val; 
      },
      visible(val) {
        this.$emit('input', val);
      }
    },
    methods: {
      oncancel() {
        this.visible = false;
        this.loading = false;
        this.count = -1;
        if(this.timer) clearInterval(this.timer);
        this.$refs["form"].resetFields();
      },
      onconform() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            checkVerificationCode({
              mobile: this.form.cellphone,
              verificationCode: this.form.code
            }).then(res => {
              if(res.code == '0' && res.datas.checkVerificationCode) {
                this.$emit('on-pass');
                this.oncancel();
              } else {
                this.$Message.error(res.msg || this.$LocalH5('sealOrSign.validFail'));
              }
            })
          }
        })
      },
      sendCode() {
        this.$refs["form"].validateField("cellphone", valid => {
          if(!valid) {
            this.loading = true;
            getVerificationCode({
              "mobile": this.form.cellphone
            }).then(res => {
              this.loading = false;
              if(res.code == '0') {
                let count = this.count = 60;
                this.timer = setInterval(() =>{
                  this.count = count--;
                  if (this.count <=0) {
                    clearInterval(this.timer);
                  }
                }, 1000)
              } else {
                this.$Message.error(res.msg || this.$LocalH5('sealOrSign.validCodeMsg'));
              }
            })
          }
        })
      }
    }
  }
</script>